import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellProductionService } from 'app/modules/well-production-status/services/well-production-status.service';
import module from "app/modules/well-production-status/well-production-status.module";

@Component({
  selector: 'app-confirmation-modal-dialog',
  templateUrl: './confirmation-modal-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: module,
  styleUrls: ['./confirmation-modal-dialog.component.scss']
})
export class ConfirmationModalDialogComponent {
  public isSuccess: boolean = false
  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<ConfirmationModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public wellProdDetails: any,
    public dialog: MatDialog,
    private wellProdServices: WellProductionService) {
  }

  confirmUpdate() {
    console.log(this.wellProdDetails)

    let wellProdBody = {
      wellStringId: this.wellProdDetails.wellStringId,
      status: this.wellProdDetails.prodStatus,
      wellType: this.wellProdDetails.wellType,
      flowCategory: this.wellProdDetails.flowCategory
    }

    this.wellProdServices.updateWellProdStatus(wellProdBody).subscribe((res) => {
      if (res.isSuccess) {
        this.isSuccess = true
        this.closeDialog()
      }
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }
}

